import i18n from '@/i18n';
import { DataType, FilterType } from '@colven/common-domain-lib/lib';

export const FORWARD_HEADERS = [
    {
        text: i18n.t('forward.table.unitId'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'unitId',
        spinner: false,
        width: 200,
    },
    {
        text: i18n.t('forward.table.urls'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'urlsString',
        spinner: false,
        width: 200,
    }
]

export const FORWARD_ENVIROMENTS = {
    TESTING: { name: "TESTING", URL: "https://testing.appg2020.com/telemetria/data", key: "TESTING" },
    STAGING: { name: "STAGING", URL: "https://staging.appg2020.com/telemetria/data", key: "STAGING" },
    CUSTOM: { name: "CUSTOM", key: "CUSTOM" }
}